import { create } from 'zustand';

import type { TriggerDefinitionDTO } from '../types/dto';
import type { RuleDraft, ConditionGroup, FormAction } from '../types/rule';

/**
 * ESTADOS DE LOADING PARA CADA ETAPA DO WIZARD
 */
export type LoadingState = {
  isLoadingGeneral: boolean; // Salvando informações gerais
  isLoadingTrigger: boolean; // Salvando trigger
  isLoadingConditions: boolean; // Salvando condições
  isLoadingActions: boolean; // Salvando ações
  isLoadingFinish: boolean; // Finalizando regra
  isHydrating: boolean; // Hidratando dados (modo edição)
  currentOperation: string | null; // Descrição da operação atual
};

type RuleState = {
  draft: RuleDraft;
  selectedTrigger: TriggerDefinitionDTO | null;
  previousTriggerUuid: string | null; // Para detectar mudança de trigger
  existingTriggerUuid: string | null; // UUID do trigger salvo no backend
  loading: LoadingState; // ✅ NOVO: Estados de loading
  setGeneral: (p: Partial<RuleDraft>) => void;
  setSelectedTrigger: (trigger: TriggerDefinitionDTO | null) => void;
  setPreviousTriggerUuid: (uuid: string | null) => void;
  setExistingTriggerUuid: (uuid: string | null) => void;
  setConditionsRoot: (root?: ConditionGroup) => void;
  setActions: (actions: FormAction[]) => void;
  setLoading: (loading: Partial<LoadingState>) => void; // ✅ NOVO
  reset: () => void;
};

export const useRuleStore = create<RuleState>(set => ({
  draft: {
    name: '',
    description: '',
    isActive: true,
    organization_uuid: '',
    actions: [],
  },
  selectedTrigger: null,
  previousTriggerUuid: null,
  existingTriggerUuid: null,
  loading: {
    isLoadingGeneral: false,
    isLoadingTrigger: false,
    isLoadingConditions: false,
    isLoadingActions: false,
    isLoadingFinish: false,
    isHydrating: false,
    currentOperation: null,
  },

  setGeneral: (p: Partial<RuleDraft>) => set(s => ({ draft: { ...s.draft, ...p } })),

  setSelectedTrigger: (trigger: TriggerDefinitionDTO | null) =>
    set(() => ({ selectedTrigger: trigger })),

  setPreviousTriggerUuid: (uuid: string | null) => set(() => ({ previousTriggerUuid: uuid })),

  setExistingTriggerUuid: (uuid: string | null) => set(() => ({ existingTriggerUuid: uuid })),

  setConditionsRoot: root => set(s => ({ draft: { ...s.draft, conditionsRoot: root } })),

  setActions: actions => set(s => ({ draft: { ...s.draft, actions } })),

  setLoading: (loading: Partial<LoadingState>) =>
    set(s => ({ loading: { ...s.loading, ...loading } })),

  reset: () =>
    set(() => ({
      draft: {
        name: '',
        description: '',
        isActive: true,
        organization_uuid: '',
        created_by: undefined,
        actions: [],
      },
      selectedTrigger: null,
      previousTriggerUuid: null,
      existingTriggerUuid: null,
      loading: {
        isLoadingGeneral: false,
        isLoadingTrigger: false,
        isLoadingConditions: false,
        isLoadingActions: false,
        isLoadingFinish: false,
        isHydrating: false,
        currentOperation: null,
      },
    })),
}));
